export const getAutresData = () => ({
  name: "Autres régions du Mexique",
  country: "Mexique",
  description: "En dehors des grandes régions viticoles, le Mexique compte de nombreux petits bassins de production, souvent en altitude, qui expérimentent avec des cépages variés et des styles innovants.",
  type: "region",
  mapAreas: [
    { region: "Zacatecas", x: 38, y: 55, color: "#b07fa1", size: 1 },
    { region: "Guanajuato", x: 42, y: 58, color: "#b07fa1", size: 1 },
    { region: "Aguascalientes", x: 40, y: 56, color: "#b07fa1", size: 1 },
    { region: "San Luis Potosí", x: 44, y: 54, color: "#b07fa1", size: 1 },
    { region: "Sonora", x: 30, y: 40, color: "#b07fa1", size: 1 },
    { region: "Chihuahua", x: 32, y: 45, color: "#b07fa1", size: 1 }
  ],
  statistics: {
    totalArea: "300 ha (ensemble)",
    production: "0.02 million hectolitres",
    appellations: "Aucune (régions libres)",
    subregions: "Divers bassins",
    exportPercentage: "1%"
  },
  characteristics: {
    climate: "Climats variés : semi-aride, tempéré, altitude élevée",
    soil: "Sols divers : calcaires, argileux, sableux",
    viticulture: "Expérimentation variétale, petits producteurs, innovation"
  },
  wineStyles: {
    red: "Rouges fruités, parfois puissants, souvent en assemblage",
    white: "Blancs frais, aromatiques, parfois minéraux",
    rose: "Rosés vifs et fruités",
    sparkling: "Production confidentielle de bulles"
  },
  history: "Ces régions émergent depuis les années 2000, portées par de jeunes vignerons et l'intérêt croissant pour le vin mexicain. Elles contribuent à la diversité et à l'innovation du paysage viticole national.",
  foodPairing: "Cuisine régionale mexicaine, plats épicés, fromages, grillades."
}); 